import React from 'react'
import { Box, Heading, Text } from "@chakra-ui/react";
import { Link } from "react-router-dom";
const NoRoutes = () => {
  return (
    <Box textAlign="center">
  <Heading size="4xl" mb="8">
    404
  </Heading>
  <Text fontSize="2xl" fontWeight="bold" mb="4">
    Page not found
  </Text>
  <Text fontSize="xl" mb="8">
    The page you are looking for does not exist or has been removed.
  </Text>
  <Link to="/" textDecoration="underline">
    Go back home
  </Link>
</Box>
  )
}

export default NoRoutes

